export const fetchAddressSLP = (ethAddress: string) => {
  return fetch(
    `https://lunacia.skymavis.com/game-api/clients/${ethAddress}/items/1`
  ).then((response) => response.json());
};

export const fetchAddressProfile = (ethAddress: string) => {
  return fetch(
    `https://axie.zone/func/profile_content.php?eth_addr=${ethAddress}`
  ).then((response) => response.json());
};
